(function() {
    'use strict';

a3_pilot_reports.factory('PilotReportTemplateFactory',PilotReportTemplateFactory);

    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name PilotReportTemplateItemFactory
    * @description 
    *   Manage Pilot Report Template Item.
    * @ngInject
    */
function PilotReportTemplateFactory($log,localStorageMD5Service,GenericService){

        /**
        * Initialize the PilotReportTemplate
        * @memberof PilotReportTemplateFactory
        */
        function PilotReportTemplate() {
            this.Sections = new Array();
            this.getDescription = getDescription;
        }
    
        /**
        * Initialize the PilotReportTemplateItem
        * @memberof PilotReportTemplateFactory
        */
        function PilotReportTemplateItem() {
			this.Id = null;
			this.Description = null;
			this.Label = null;
			this.OrderNo = null;
			this.CategoryLabel = null;
			this.PresetComments = null;
		}
    
        /**
        * Initialize the PilotReportTemplateSection
        * @memberof PilotReportTemplateFactory
        */
        function PilotReportTemplateSection() {
            this.Id = null;
            this.Label = null;
            this.OrderNo = null;
            this.Items = new Array();
	   }
    
		function getDescription() {
			if (this.Sections == null) return '-null-';
			else return this.Sections.length;
		}
		 
		var service = 
				{
                    getPilotReportTemplateFromStorage : getPilotReportTemplateFromStorage,
                    setPilotReportTemplateToStorage : setPilotReportTemplateToStorage,
                    clearPilotReportTemplateFromStorage : clearPilotReportTemplateFromStorage          
				}
		
	function fromObject(obj) {
		if (obj==null) return null;
		var rptt = new PilotReportTemplate();
		angular.extend(rptt, obj);
		
		// extend sections
		var sectionsTemp = rptt.Sections.slice();
		rptt.Sections = new Array;
		
		var sectionCount = sectionsTemp.length;
		for (var i = 0; i < sectionCount; i++) {
			
			var sct = new PilotReportTemplateSection();
			angular.extend(sct, sectionsTemp[i]);
			rptt.Sections.push(sct);

			// extend section items
			var itemsTemp = sectionsTemp[i].Items.slice();
			sct.Items = new Array();
			
			var itemCount = itemsTemp.length;
			for (var j = 0; j < itemCount; j++) {
				
				var itm = new PilotReportTemplateItem();
				angular.extend(itm, sectionsTemp[i].Items[j]);
				sct.Items.push(itm);
				
			}
			
		}
		
		return rptt;
	};
	
    /**
     * Get Pilot Report Template Items
     * @memberof PilotReportTemplateItemFactory
     * @returns {Array} PilotReportTemplateItems 
     */
	function getPilotReportTemplateFromStorage(){
		var pilotReportTemplate = localStorageMD5Service.get('pilotReportTemplate');
		return fromObject(pilotReportTemplate);
	}

    /**
     * Save Pilot Report Template Items to storage
     * @memberof PilotReportTemplateItemFactory
     * @param {Array} PilotReportTemplateItems A list of Pilot Report Template Items
     */
	function setPilotReportTemplateToStorage(pilotReportTemplate){
		localStorageMD5Service.set('pilotReportTemplate',pilotReportTemplate);
	}

      /**
     * Clear Pilot Report Template from storage
     * @memberof PilotReportTemplateItemFactory
     * @param {Array} PilotReportTemplateItems A list of Pilot Report Template Items
     */
	function clearPilotReportTemplateFromStorage(){
		localStorageMD5Service.remove('pilotReportTemplate');
	}

	// Return constructor - this is what defines the actual
	// injectable in the DI framework.
	return service;
}

 })();   